<template>
  <div>
    <div v-show="true">
      <h4 class="ui dividing header">
        <i class="github icon"></i> {{ $t("connection settings") }}
      </h4>
      <div class="ui form">
        <h5 class="ui dividing header">{{ $t("project repository") }}</h5>
        <div class="two fields">
          <div class="field">
            <label for="">{{ $t("user") }}</label>
            <input type="text" name="user" v-model="config.user" />
          </div>
          <div class="field">
            <label for="">{{ $t("password") }}</label>
            <input type="password" name="password" v-model="config.password" />
          </div>
        </div>
      </div>
    </div>
    <div class="ui icon menu">
      <a class="item" @click="check">
        <i class="lightning icon" v-bind:class="{ loading: processing }"></i>
        {{ $t("check") }}
      </a>
      <a class="item" @click="apply">
        <i class="check icon" v-bind:class="{ loading: processing }"></i>
        {{ $t("apply") }}
      </a>
    </div>
    <h5 class="ui dividing header">{{ $t("update log") }}</h5>
    <editor
      @init="init_editor"
      v-model="log"
      lang="text"
      theme="monokai"
    ></editor>
  </div>
</template>

<script>
import { local_api, error_toast, enterprise_setup } from "@/utils";
import Editor from "vue2-ace-editor";

export default {
  name: "ApplicationManagement",
  data() {
    return {
      processing: false,
      config: {
        user: "strato0100",
        password: "Yaniraileana0",
      },
      log: "",
    };
  },
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
    url() {
      return `https://${this.config.user}:${this.config.password}@bitbucket.org/strato0100/swissknife.git`;
    },
  },
  components: { Editor },
  watch: {},
  methods: {
    check() {
      let vm = this;
      vm.processing = true;
      local_api(vm, "post", "/system/management/do-check-app", {})
        .then((r) => {
          vm.log = r;
          vm.processing = false;
        })
        .catch((err) => {
          error_toast(err);
          vm.processing = false;
        });
    },
    init_editor() {
      require("brace/mode/sql");
      require("brace/theme/monokai");
    },
    apply() {
      let vm = this;
      vm.processing = true;
      local_api(vm, "post", "/system/management/do-update-app", { url: vm.url })
        .then((r) => {
          vm.log = r;
          vm.processing = false;
        })
        .catch((err) => {
          vm.log += JSON.stringify(JSON.parse(err), null, 2) + "\n\n";
          vm.processing = false;
        });
    },
  },
  mounted() {
    window
      .jQuery(this.$refs.tabs)
      .find(".item")
      .tab();
  },
};
</script>

<style scoped></style>
